import { PermissionCategory } from './../../enums/permission-category.enum';
import { PagedRequestDto } from './../paged-request.model';
export interface CorporatePermissionsParameters extends PagedRequestDto {
  category?: PermissionCategory;
  isActive?: boolean;
}
